import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { authClient } from '@/shared/api/clients/authClient';
import { useSessionStore } from '@/shared/store/sessionStore';

export function useSessionQuery(scope: 'family' | 'admin' = 'family') {
  const query = useQuery({
    queryKey: ['session', scope],
    queryFn: () => authClient.session(scope),
    staleTime: 60_000,
    retry: false,
  });

  const login = useSessionStore((s) => s.login);
  const loginAdmin = useSessionStore((s) => s.loginAdmin);
  const logout = useSessionStore((s) => s.logout);
  const setHydrated = useSessionStore((s) => s.setHydrated);

  useEffect(() => {
    if (!query.isSuccess) return;
    const data = query.data as { profile: { familyId: string; loginIdentifier?: string } | null; isAdmin?: boolean } | null;
    if (scope === 'admin') {
      if (data?.isAdmin) loginAdmin();
      else logout('admin');
    } else if (data?.profile && !data.isAdmin) {
      login(data.profile.loginIdentifier ?? data.profile.familyId);
    } else logout('family');
    setHydrated();
  }, [scope, query.isSuccess, query.data, login, loginAdmin, logout, setHydrated]);

  useEffect(() => {
    if (query.isError) setHydrated();
  }, [query.isError, setHydrated]);

  return query;
}
